import { useState, useEffect  } from "react";

import {
  Avatar,
  AvatarGroup,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Tab,
  Typography,
  Box,
  styled,
} from "@mui/material";
import TeamAvatars from "components/TeamAvatars";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { tss } from "tss-react";
import * as Utils from "services/UtilsService";
import { Div } from "themes/jumbo/@jumbo/shared";
import { JumboCard } from "themes/jumbo/@jumbo/components";
import { TabContext, TabList } from "@mui/lab";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SignalWifiStatusbarNullOutlinedIcon from '@mui/icons-material/SignalWifiStatusbarNullOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { UserTeam } from "components/UserTeam";
import { Button} from "@mui/material";
import AuthService from "services/AuthService";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import UserAdd from "components/UserAdd";
import { openDialog } from 'store/main/userManagement';
//import Scrollbars from "react-custom-scrollbars";
import CustomScroll from "components/CustomScroll";
import { hideNotification } from 'store/main/userManagement';
import { openDialogUpgrade} from "store/main/userSettingsDialog";
//import { fetchUsagePlan} from "store/main/usagePlan";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import jwtService from 'services/jwtService';
import UpgradeContact from "components/UpgradeContact";
import { useHistory } from 'react-router-dom';
import { trackEvent } from "components/Tracking";

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 24,
  height: 48,
  width: 48,
  borderRadius: "50%",
  minWidth: 42,
  marginRight: 16,
  padding: theme.spacing(1),
  alignItems: "center",
  justifyContent: "center",
  border: `solid 1px ${theme.palette.divider}`,
}));

const useStyles = tss.create({
	root: {
		paddingLeft: 45,
		paddingTop: 35,
	},
	table: {
		width: "100%",
	},
	row: {
		borderBottom: "1px solid rgba(0,0,0,0.1)",
		height: 35,
	}
});


const About = (props:any) => {
	
	const dispatch = useDispatch<any>();
	const history = useHistory();
	const { classes} = useStyles();
	
	const ipn_name = useSelector((state: RootState) => state.auth.data.ipn_name);
	const ipn_pcode = useSelector((state: RootState) => state.auth.data.ipn_pcode);
	const dataProcess = useSelector((state:RootState) => state.auth.data.usageData)

	console.log("Data process : " + JSON.stringify(dataProcess))
	const planStore = useSelector((state:RootState) => state.auth.data)

	const limit_processtime = useSelector((state:RootState) => state.auth.data.limit_processtime)
	const process_used =  Object.keys(dataProcess).length === 0 || limit_processtime === 0 ? 0 : dataProcess?.result === 'error' ? 0 : (dataProcess[0].hours / limit_processtime)*100; //(tval / limit_processtime)*100;

	const active_user = useSelector((state:RootState) => state.main.addMember.active_user)
	const max_user = useSelector((state:RootState) => state.main.addMember.max_user)

	const {plan, team, role, tab} = props;

	const [value, setValue] = useState<string>("1");
	const [gValue, setGValue] = useState(0);
	const [usage, setUsage] = useState(0);
	const [color, setColor] = useState('#4caf50');
	const MAX_SCROLLER_HEIGHT = 300;

	const handleChange = (event:any, newValue: string) => {
		if(newValue === '1'){
			history.push('/profile')
		}else if(newValue === '2'){
			history.push('/profile/team')
		}else if(newValue === '3')
			history.push('/profile/developer')

		setValue(newValue);
	};

	// const renew = (e:any) => {
	// 	e.preventDefault()
	// 	const url = "https://secure.2checkout.com/renewal/?LICENSE=" + subscription_reference + '&PRODS=' + ipn_pcode + '&QTY=' + ipn_qty;
	// 	window.open(url, '_blank');
	// }

	const settings = {
		width: 100,
		height: 100,
		value: typeof usage !== "undefined" ? gValue : 0,
	};

	const copyAuthToken = () => {
		Utils.copyContent(AuthService.getToken(), (result: string) => {});
	};

	const upgrade = async (e:any, ipn_name : any, ipn_pcode : any, keep : boolean) => {
		e.preventDefault()

		const url = "https://secure.2checkout.com/order/upgrade.php?LICENSE=" + planStore.subscription_reference + '&PROD=' + ipn_pcode;
		console.log("URL : " + url)

		if(keep) {
			const url = "https://secure.2checkout.com/renewal/?LICENSE=" + planStore.subscription_reference + '&PROD=' + planStore.ipn_pcode;
			window.open(url, '_blank');
		}else{
			if(ipn_name === 'Standard' || ipn_name === 'Business'){

				dispatch(openDialogUpgrade({}))

			}else if(ipn_name === 'Basic' || ipn_name === 'Starter') {

				const url = "https://secure.2checkout.com/order/upgrade.php?LICENSE=" + planStore.subscription_reference + '&PROD=' + planStore.ipn_pcode;
				window.open(url, '_blank');

			}else{

				const url = "https://voxelspace.com/#pricing";
				window.open(url, '_blank');
			}
		}
	}
	

	const addUser = async (e:any) => {
		e.preventDefault()
		dispatch(hideNotification())

		try{
			const endpoint = process.env.REACT_APP_BASE_URL + '/v2/subscription/products';

			let response = await jwtService.fetchRequest({
				method: 'POST',
				url: endpoint,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				data: {email : btoa(AuthService.userEmail), key_id : process.env.REACT_APP_BASE_APIKEY}
			});
			const result = response.data;
			
			if(result){
				dispatch(openDialog({email:AuthService.userEmail, product:result.data[0].prdt_code, subscription:result.data[0].subscription_reference, remains: result.data.length}))
			}

		}catch(err){
			console.log(err);
		}
	}

	
	useEffect(() => {

		if(tab === 'team')
			setValue('2')
		else if (tab === 'developer')
			setValue('3')
		else 
			setValue('1')
		
		//const randomInteger = 85;
		if(process_used > 0 && process_used <= 30){
			setColor('#52b202')
		}
		else if(process_used > 30 && process_used < 70){
			setColor('#ff9800')
		}
		else{
			setColor('#f44336')
		}

	  	//setGValue(process_used)
		setGValue(process_used)
		
	}, [gValue, process_used, tab])
	
  	return (
		<>
		<UpgradeContact />
		<JumboCard
		title={"Profile"}
		action={
			<TabContext value={value}>
			<Div
				sx={{
				marginTop: -2.25,
				marginBottom: -2.5,
				"& .MuiTab-root": {
					py: 2.5,
				},
				}}
			>
				<TabList aria-label="lab API tabs example" onChange={handleChange}>
				<Tab label="My Plan" value="1" />
				{
				plan.length > 0 && role === 'admin'
				?
					<Tab label="My Team" value="2" />
				: ''
				}
				<Tab label="Developer" value="3" />
				
				</TabList>
			</Div>
			</TabContext>
		}
		headerSx={{
			borderBottom: 1,
			borderColor: "divider",
		}}
		contentWrapper
		>
		{
		value === '1' && (
			<CustomScroll
						autoHeight
						autoHeightMax={MAX_SCROLLER_HEIGHT + 50}
						style={{ overflowX: "hidden" }}
					>
				<List
					disablePadding
					sx={{
						display: "flex",
						flexWrap: "wrap",
						margin: (theme) => theme.spacing(0, -2),
					}}
					style={{ width: "100%", overflowX: "hidden" }}
				>
					
					<ListItem
					sx={{
						width: { xs: "100%", sm: "50%", xl: "33.33%" },
					}}
					>
					<StyledListItemIcon>
						<EmailOutlinedIcon fontSize={"inherit"} />
					</StyledListItemIcon>
					<ListItemText
						primary={
						<Typography
							fontSize={"12px"}
							variant="h6"
							color="text.secondary"
							mb={0.5}
						>
							Purchase Email
						</Typography>
						}
						secondary={
						<Typography variant="body1" color="text.primary">
							{planStore.purchase_email}
						</Typography>
						}
					/>
					</ListItem>
					<ListItem
					sx={{
						width: { xs: "100%", sm: "50%", xl: "33.33%" },
					}}
					>
					<StyledListItemIcon>
						<GavelOutlinedIcon fontSize={"inherit"} />
					</StyledListItemIcon>
					<ListItemText
						primary={
						<Typography
							fontSize={"12px"}
							variant="h6"
							color="text.secondary"
							mb={0.5}
						>
							Order Number
						</Typography>
						}
						secondary={
						<Typography variant="body1" color="text.primary">
							{planStore.refno}
						</Typography>
						}
					/>
					</ListItem>
					<ListItem
					sx={{
						width: { xs: "100%", sm: "50%", xl: "33.33%" },
					}}
					>
					<StyledListItemIcon>
						<Inventory2OutlinedIcon fontSize={"inherit"} />
					</StyledListItemIcon>
					<ListItemText
						primary={
						<Typography
							fontSize={"12px"}
							variant="h6"
							color="text.secondary"
							mb={0.5}
						>
							Product
						</Typography>
						}
						secondary={
						<Typography variant="body1" color="text.primary">
							{planStore.ipn_name}
						</Typography>
						}
					/>
					</ListItem>
					<ListItem
						sx={{
							width: { xs: "100%", sm: "50%", xl: "33.33%" },
						}}
						>
						<StyledListItemIcon>
							<SignalWifiStatusbarNullOutlinedIcon fontSize={"inherit"} />
						</StyledListItemIcon>
						<ListItemText
							primary={
							<Typography
								fontSize={"12px"}
								variant="h6"
								color="text.secondary"
								mb={0.5}
							>
								Status
							</Typography>
							}
							secondary={
								planStore.subscription_status === 'ACTIVE' ? 
								<Typography variant="body1" color={'success'}>
									{planStore.subscription_status}
								</Typography>
								:
								<Typography variant="body1" color={'error'}>
									{planStore.subscription_status}
								</Typography>
								}
						/>
					</ListItem>

					<ListItem
					sx={{
						width: { xs: "100%", sm: "50%", xl: "33.33%" },
					}}
					>
					<StyledListItemIcon>
						<DateRangeOutlinedIcon fontSize={"inherit"} />
					</StyledListItemIcon>
					<ListItemText
						primary={
						<Typography
							fontSize={"12px"}
							variant="h6"
							color="text.secondary"
							mb={0.5}
						>
							Expiration Date
						</Typography>
						}
						secondary={
						<Typography variant="body1" color="text.primary">
							{planStore.expirationDate}
						</Typography>
						}
					/>
					</ListItem>
					
					<ListItem
					sx={{
						width: { xs: "100%", sm: "50%", xl: "33.33%" },
					}}
					>
					<StyledListItemIcon>
						<GroupsOutlinedIcon fontSize={"inherit"} />
					</StyledListItemIcon>
					<ListItemText
						primary={
						<Typography
							fontSize={"12px"}
							variant="h6"
							color="text.secondary"
							mb={0.5}
						>
							Active users
						</Typography>
						}
						secondary={
							<TeamAvatars teams={planStore.teams} />
						}
					/>
					</ListItem>
					
					{
					((planStore.subscription_status === 'EXPIRED' || planStore.subscription_status === 'PASTDUE') && role === 'admin') ? 
					<ListItem
						sx={{
							width: { xs: "100%", sm: "50%", xl: "33.33%" },
							order: { xs: 2, sm: 1 },
						}}
						>
						<ListItemText>
						<Button 
							onClick={(e:any) => {
								trackEvent("UserProfile", "Renew", ipn_name); 
								upgrade(e, ipn_name, ipn_pcode, true);
							}} 
							color="primary"
							variant="contained" 
							startIcon={<UpgradeIcon fontSize="small"/>} 
						>
							Renew
							</Button>
						</ListItemText>
					</ListItem>
					:
					(planStore.subscription_status === 'ACTIVE' && role === 'admin') ?
					<ListItem
						sx={{
							width: { xs: "100%", sm: "50%", xl: "33.33%" },
							order: { xs: 2, sm: 1 },
						}}
						>
						<ListItemText>
						<Button 
							onClick={(e:any) => {
								trackEvent("UserProfile", "Upgrade", ipn_name); 
								upgrade(e, ipn_name, ipn_pcode, false)
							} 
							}
							color="primary"
							variant="contained" 
							startIcon={<UpgradeIcon fontSize="small"/>} 
						>
							Upgrade
							</Button>
						</ListItemText>
					</ListItem>
					:
					''
					}
								
					<ListItem
					sx={{
						width: { xs: "50%", sm: "50%", xl: "33.33%" },
						order: { xs: 1, sm: 2 },
					}}
					>
						<ListItemText
							secondary={
								<Typography variant="body1" color="text.primary">
									<Box display="flex" flexDirection="row" alignItems="center" style={{ maxWidth: '300px'}}>
										<Typography variant="body2" component="div" style={{ marginTop: '5px', textAlign: 'center', color: '#3DABE6' }}>
											Process Time
										</Typography>
										<Gauge
											{...settings}
											sx={(theme) => ({
												[`& .${gaugeClasses.valueText}`]: {
												fontSize: 22,
												},
												[`& .${gaugeClasses.valueText} text`]: {
												fill: "#3DABE6" 
												},
												[`& .${gaugeClasses.valueArc}`]: {
													fill: color,
												},
												})
											}
											text={
											({ value }) => parseInt(`${process_used}`) + '%'
											}
																	
											/>
										
										<Typography variant="body2" component="div" style={{ marginTop: '5px', textAlign: 'center' }}>
											{ (Object.keys(dataProcess).length !== 0 && dataProcess?.result !== 'error') ? '(' + Math.round(dataProcess[0].hours*100)/100 + '/' + limit_processtime + ') hours' : 'No process run' } 
										</Typography>
									</Box>
								</Typography>
							}
						/>
					</ListItem>
					
				</List>
				</CustomScroll>
			)}
			{
			value === '2' && (
				<div>
					{
					active_user < max_user && planStore.subscription_status === 'ACTIVE' ? 
					<div style={{ display:'flex'}}>
									
						<Button 
							onClick={(e:any) => {
								trackEvent("UserProfile", "My Team", "Add member"); 
								addUser(e)
							}} 
							style={{backgroundColor: '#fff', color:'#000', marginLeft: 'auto'}} 
							variant="contained" 
							startIcon={<PersonAddIcon fontSize="small"/>} 
						>
						Add new user
						</Button>
					</div>
					:
						planStore.ipn_name === 'free' && ( 
						<>
						No team found
						<br/><br/>
						<Button 
							onClick={(e:any) => {
								trackEvent("UserProfile", "My Team", "Upgrade"); 
								upgrade(e, ipn_name, ipn_pcode, false);
							}} 
							color="primary"
							variant="contained" 
							startIcon={<UpgradeIcon fontSize="small"/>} 
						>
							Upgrade
							</Button>
						</>
						)
					}	
				
					<CustomScroll
						autoHeight
						autoHeightMax={MAX_SCROLLER_HEIGHT}
						style={{ marginTop: 20, overflowX: "hidden" }}
					>
					
					<div style={{padding: '10px 0', margin:'0px 20px 0px', height: '180px'}}>
					{
					team.map((item:any, index:any) => <UserTeam item={item} key={index} subscription_status={planStore.subscription_status}/>)
					}
					</div>
					</CustomScroll>
				</div>
			)}
			{value === '3' && (
        		<table className={classes.table} cellSpacing={0} cellPadding={0} style={{ paddingTop: 15 }}>
					<tbody>
						
						 <tr>
							<td>
								You will need an access token to run a Python script and interact with our API. The token authenticates your requests and ensures secure communication.
							</td>
						</tr>
						<tr style={{textAlign:'center'}}>
							<td className={classes.row} style={{ border: 0 }}>
								<Button 
								color="primary" 
								variant="contained" 
								startIcon={<ContentCopyIcon fontSize="small"/>} onClick={() => {
									trackEvent("UserProfile", "Developer", "Copy Token");
									copyAuthToken();
									}}>
									Copy Authorization Token
								</Button>
							</td>
						</tr>
					</tbody>
				</table>
      		)
			
		}
		</JumboCard>
		<UserAdd />
	</>
  );
};

export { About };
